import { TFunction } from 'i18next';

import { TravelReferenceDocumentSlotRef } from './model/TravelReferenceDocumentTypes';

// Only the admin list names the role: a reader's resolved guide is "the guide" whichever slot it came from.
export function getTravelReferenceDocumentSlotLabel(t: TFunction, slot: TravelReferenceDocumentSlotRef) {
  if (slot.kind !== 'USER_GUIDE') {
    return t(`travel.referenceDocuments.kindEnum.${slot.kind}`);
  }
  if (slot.role == null) {
    return t('travel.referenceDocuments.guideGeneral');
  }
  return t('travel.referenceDocuments.guideForRole', { role: t(`roleType.${slot.role}`) });
}
